module.exports = __webpack_public_path__ + "static/assets/e26e122246e7251b3ab37cda88b70ff2.svg";